import api from "./api.config";

const profile = () => {
    return api
        .get(`/api/profile/me`)
        .then((response) => {
            return response.data;
        });
};
const ProfileService = {
    profile,

};

export default ProfileService;